import { Navigate, Route, Routes } from 'react-router-dom';
import { ShopRoutes } from './shop/ShopRoutes';
import { AdminLayout } from './admin/AdminLayout';
import { Dashboard } from './admin/Dashboard';
import { OrdersList } from './admin/OrdersList';
import { OrderDetail } from './admin/OrderDetail';
import { Tickets } from './admin/Tickets';
import { Products } from './admin/Products';
import { Settings } from './admin/Settings';
import { Kiosk } from './logistics/Kiosk';
import { Login } from './admin/Login';
import { AuthProvider } from './admin/auth/AuthContext';
import { RequireOperator } from './admin/auth/RequireOperator';

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/*" element={<ShopRoutes />} />
        <Route path="/admin/login" element={<Login />} />
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/admin/zamowienia" element={<OrdersList />} />
          <Route path="/admin/zamowienia/nowe" element={<OrdersList modal="manual" />} />
          {/* Merging needs a selection that only exists in the list, so this old modal URL has no
              meaning on its own - and left unhandled it matches :id and queries for order "polacz". */}
          <Route
            path="/admin/zamowienia/polacz"
            element={<Navigate to="/admin/zamowienia" replace />}
          />
          <Route path="/admin/zamowienia/:id" element={<OrderDetail />} />
          <Route path="/admin/bilety" element={<Tickets />} />
          <Route path="/admin/bilety/dodaj" element={<Tickets modal="add" />} />
          <Route path="/admin/produkty" element={<Products />} />
          <Route path="/admin/ustawienia" element={<Settings />} />
        </Route>
        <Route
          path="/logistyka"
          element={
            <RequireOperator>
              <Kiosk />
            </RequireOperator>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
